module.exports = __webpack_public_path__ + "static/media/tui_white.07bd98ad.svg";